import React, { useEffect } from "react";
import "./ConfirmOrder.scss";
import { useNavigate } from "react-router-dom";

function ConfirmOrder() {
  const navigate = useNavigate(); // Get the navigate function from the useNavigate hook

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     navigate("/myaccount#OrderPart");
  //   }, [5000]);

  //   return () => clearTimeout(timer);
  // }, [navigate]);
  //dones
  return (
    <>
      <div className="main-order">
        <div className="confirmPage">
          <h2> Your order has been successfully.</h2>
          <div className="icon">
            <i class="bi bi-check-circle"></i>
          </div>
          <p className="mt-3">
            Your order will be delivered within 5 days.
            <br />
            We are getting started on your order right away, and you will
            receive an order confirmation email.
          </p>
          <div className="btn-div">
            <button
              className="btn"
              onClick={() => {
                navigate('/myaccount#OrderPart"');
                window.scrollTo(0, 0);
              }}
            >
              Order Details
            </button>
            <button
              className="btn"
              onClick={() => {
                navigate("/allProduct");
                window.scrollTo(0, 0);
              }}
            >
              Continue Shoping
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConfirmOrder;
